"use client";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState, forwardRef } from "react";
import cx from "classnames";
import pause from "@ingka/ssr-icon/paths/pause";
import play from "@ingka/ssr-icon/paths/play";
import Button from "@ingka/button";
const SimpleVideo = forwardRef(
  (props, ref) => {
    const {
      prefix = "",
      customOnClickAriaLabel = "Video action",
      descriptionId,
      descriptionBody,
      onClick,
      className,
      playAriaLabel = "play",
      pauseAriaLabel = "pause",
      videoNotSupportedTxt = "Sorry, your browser doesn\u2019t support embedded videos.",
      autoPlay = true,
      ...others
    } = props;
    const [playing, setPlaying] = useState(autoPlay);
    const [centerButtonFading, setCenterButtonFading] = useState(false);
    const [cornerButton, setCornerButton] = useState(autoPlay);
    const video = ref || useRef(null);
    function onKeyUpHandler(e) {
      if (e.key !== "Enter" && e.key !== " ") {
        return true;
      }
      e.target.click();
    }
    useEffect(() => {
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        setPlaying(false);
      }
    }, []);
    const toggleVideoPlayback = () => {
      const videoRef = video;
      playing ? videoRef.current?.pause() : videoRef.current?.play();
      setPlaying(!playing);
      if (!autoPlay && !cornerButton) {
        setCenterButtonFading(true);
      }
    };
    const baseClass = `${prefix}simple-video`;
    const classes = cx(`${baseClass}`, className);
    const actionClasses = cx(
      `${baseClass}__video-action`,
      onClick && `${baseClass}__video-action--custom-click`
    );
    const playbackAriaLabel = playing ? pauseAriaLabel : playAriaLabel;
    const containerClasses = cx(
      `${baseClass}__button-container`,
      !autoPlay && centerButtonFading && `${baseClass}__button-container--fading`,
      cornerButton && `${baseClass}__button-container--corner`
    );
    const onTransitionEnd = () => {
      setCornerButton(true);
      setCenterButtonFading(false);
    };
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "video",
        {
          ref: video,
          className: classes,
          playsInline: true,
          "aria-describedby": descriptionId,
          onKeyUp: onKeyUpHandler,
          muted: true,
          loop: true,
          autoPlay: autoPlay ? autoPlay : false,
          ...others,
          children: videoNotSupportedTxt
        }
      ),
      /* @__PURE__ */ jsx(
        "button",
        {
          className: actionClasses,
          "aria-label": onClick ? customOnClickAriaLabel : playbackAriaLabel,
          onClick: onClick ? onClick : toggleVideoPlayback
        }
      ),
      /* @__PURE__ */ jsx("div", { className: containerClasses, onAnimationEnd: onTransitionEnd, children: /* @__PURE__ */ jsx(
        Button,
        {
          "aria-hidden": !onClick,
          tabIndex: onClick ? 0 : -1,
          onClick: toggleVideoPlayback,
          prefix,
          size: cornerButton ? "small" : "medium",
          ssrIcon: playing ? pause : play,
          className: `${baseClass}__button`,
          text: playbackAriaLabel,
          iconOnly: true,
          type: "image-overlay"
        }
      ) }),
      /* @__PURE__ */ jsx("div", { id: descriptionId, className: `${baseClass}__description`, children: descriptionBody })
    ] });
  }
);
SimpleVideo.displayName = "SimpleVideo";
var SimpleVideo_default = SimpleVideo;
export {
  SimpleVideo,
  SimpleVideo_default as default
};
